// src/components/ScoreCard.tsx
import { useEffect, useState } from 'react';
import authAxios from '../auth/authAxios';
import { useScoreContext } from '../ScoreContext';

const ScoreCard: React.FC = () => {
  const [score, setScore] = useState<number>(2.0);
  const [level, setLevel] = useState<string>("Beginner");
  const [testsTaken, setTestsTaken] = useState<number>(0.0);
  const [averageScore, setAverageScore] = useState<number>(0.0);
  const { refreshKey } = useScoreContext();

  useEffect(() => {
    authAxios.get('/api/scores/summary').then(res => {
      const { score, lessons_attempted, average_top_score } = res.data;

      const parsedScore = parseFloat(score);
      setScore(parsedScore);
      setLevel(parsedScore >= 8 ? 'Expert' : parsedScore >= 6.667 ? 'Proficient' : parsedScore >= 4.5 ? 'Improving' : 'Beginner');
      setTestsTaken(parseFloat(lessons_attempted) || 0);
      setAverageScore(parseFloat(average_top_score) || 0);
    });
  }, [refreshKey]); 
  
  return (
    <div className="w-fit max-w-sm rounded-xl bg-bg-panel bg-opacity-90 backdrop-blur-sm border border-white/10 shadow-[0_0_10px_rgba(79,255,222,0.1)] p-6">
    {/* <div className="rounded-xl bg-bg-panel border border-white/10 shadow-lg p-6 text-white w-full max-w-sm"> */}
      <h3 className="text-lg font-semibold text-primary mb-1">Your AI Skill</h3>
      <p className="text-3xl font-bold text-white">{score.toFixed(1)}</p>
      <p className="text-sm text-gray-400 mt-1">Level: {level}</p>

      <div className="mt-4 border-t border-white/10 pt-3 text-sm text-gray-300">
        <p>Lessons Completed: <span className="font-semibold text-white">{testsTaken}</span></p>
        <p>Avg Score: <span className="font-semibold text-white">{averageScore.toFixed(1)}</span></p>
      </div>
    </div>
  );
};

export default ScoreCard;
